import { useCallback, useEffect, useState } from 'react'
import {
    ClaimListService,
    CustomReportService,
    ErrorConstant,
    ReportService,
    CommonConstant,
    PaginationType,
} from 'utility'
import { parseClaimListResponse } from 'page-components/customer-complaint-log/customer-claim-inspection-utils'

export const GetReport = () => {
    const [data, setData] = useState([])
    const [error, setError] = useState('')
    const [loading, setLoading] = useState(false)
    const [totalCount, setTotalCount] = useState(0)
    const [outputFile, setOutputFile] = useState('')
    const [pagination, setPagination] = useState({
        currentPage: 1,
        lastPage: 1,
        perPage: 20,
        total: 0,
        from: 1,
        to: 20,
    })
    const [filter, setFilter] = useState({
        PageNumber: 1,
        PageSize: CommonConstant.defaultPageSize,
    })

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true)
                const result = await ReportService.getReport(filter)
                setData(result.Items)
                setOutputFile(result.OutputFile)
                if (result.MetaData) {
                    setPagination({
                        currentPage: result.MetaData.CurrentPage,
                        lastPage: result.MetaData.LastPage,
                        perPage: result.MetaData.PerPage,
                        total: result.MetaData.Total,
                        from: result.MetaData.From,
                        to: result.MetaData.To,
                    })
                }
                setTotalCount(result.TotalCount)
            } catch {
                setError(ErrorConstant.default)
            } finally {
                setLoading(false)
            }
        }
        if (filter.StartDate && filter.EndDate) {
            fetchData()
        }
    }, [filter])

    const filterChanged = filterData => {
        // Reset PageNumber to 1 when filters change (not when pagination changes)
        // Check if filterData contains any filter fields other than PageNumber
        const hasFilterChanges = filterData.StartDate || filterData.EndDate ||
            filterData.Status !== undefined || filterData.TemplateId !== undefined ||
            filterData.GroupId !== undefined || filterData.UserId !== undefined ||
            filterData.customerIds !== undefined ||
            filterData.ShowExecutiveReport !== undefined

        setFilter({
            ...filter,
            ...filterData,
            PageNumber: hasFilterChanges ? 1 : (filterData.PageNumber || filter.PageNumber),
            PageSize: 20, // Always ensure PageSize is 20
        })
    }

    const pageChanged = page => {
        setFilter({
            ...filter,
            PageNumber: page,
        })
    }

    const refresh = () => {
        setFilter({
            ...filter,
        })
    }

    return {
        data,
        error,
        setData,
        loading,
        filter,
        totalCount,
        outputFile,
        pagination,
        filterChanged,
        pageChanged,
        refresh,
    }
}

export const GetCustomReport = () => {
    const [data, setData] = useState([])
    const [error, setError] = useState('')
    const [loading, setLoading] = useState(false)
    const [filter, setFilter] = useState({})

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true)
                const result = await CustomReportService.getById(filter)
                setData(result)
            } catch {
                setError(ErrorConstant.default)
            } finally {
                setLoading(false)
            }
        }
        if (filter.templateId) {
            fetchData()
        }
    }, [filter])

    const filterChanged = filterData => {
        setFilter({ ...filterData })
    }

    return {
        data,
        error,
        setData,
        loading,
        filterChanged,
    }
}

export const GetCustomComponentList = () => {
    const [data, setData] = useState([])
    const [error, setError] = useState('')
    const [loading, setLoading] = useState(false)
    const [filter, setFilter] = useState({})

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true)
                const result = await CustomReportService.getComponent({
                    callFrom: 1,
                })
                setData(result)
            } catch {
                setError(ErrorConstant.default)
            } finally {
                setLoading(false)
            }
        }
        fetchData()
    }, [filter])

    const filterChanged = filterData => {
        setFilter({ ...filterData })
    }

    return {
        data,
        error,
        setData,
        loading,
        filterChanged,
    }
}
export const GetCheckInReport = (paginationType = PaginationType.default) => {
    const [data, setData] = useState([])
    const [error, setError] = useState('')
    const [loading, setLoading] = useState(false)
    const [totalCount, setTotalCount] = useState(0)
    const [filter, setFilter] = useState({
        StartDate: '',
        EndDate: '',
        PageNumber: 1,
        PageSize: CommonConstant.defaultPageSize,
        all: paginationType,
    })
    console.log(filter)
    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true)
                const result = await ReportService.getCheckInReport(
                    !filter.all ? filter : { ...filter, PageSize: 10000 },
                )

                setData(result)
                setTotalCount(result?.TotalCount)
            } catch {
                setError('An error occurred while fetching data.')
            } finally {
                setLoading(false)
            }
        }

        if (filter.StartDate && filter.EndDate) {
            fetchData()
        }
    }, [filter])

    const pageChanged = page => {
        setFilter({
            ...filter,
            PageNumber: page,
        })
    }

    const filterChanged = filterData => {
        // Reset PageNumber to 1 when filters change (not when pagination changes)
        // Check if filterData contains any filter fields other than PageNumber
        const hasFilterChanges = filterData.StartDate || filterData.EndDate ||
            filterData.UserId !== undefined

        setFilter({
            ...filter,
            ...filterData,
            PageNumber: hasFilterChanges ? 1 : (filterData.PageNumber || filter.PageNumber),
            PageSize: 20, // Always ensure PageSize is 20
        })
    }

    const refresh = () => {
        setFilter({
            ...filter,
        })
    }

    return {
        data,
        setData,
        error,
        loading,
        filter,
        totalCount,
        pageChanged,
        filterChanged,
        refresh,
    }
}

export const GetCheckInUserReport = () => {
    const [data, setData] = useState([])
    const [error, setError] = useState('')
    const [loading, setLoading] = useState(false)
    const [filter, setFilter] = useState({
        StartDate: '',
        EndDate: '',
        userId: '',
    })

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true)
                const result = await ReportService.getCheckInUserReport(filter)
                setData(result)
            } catch {
                setError('An error occurred while fetching data.')
            } finally {
                setLoading(false)
            }
        }

        if (filter.StartDate && filter.EndDate && filter.userId) {
            fetchData()
        }
    }, [filter])

    const filterChanged = filterData => {
        setFilter({
            ...filter,
            ...filterData,
        })
    }

    return {
        data,
        error,
        loading,
        filter,
        filterChanged,
    }
}

export const GetCumulativeReport = () => {
    const [data, setData] = useState([])
    const [error, setError] = useState('')
    const [loading, setLoading] = useState(false)
    const [filter, setFilter] = useState({
        CompanyId: '',
        StartDate: '',
        EndDate: '',
        StatusList: '',
        UserIds: '',
        CustomerIds: '',
    })

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true)
                const result = await ReportService.getCumulativeReport(filter)
                setData(result)
            } catch (error) {
                setError(error.message || ErrorConstant.default)
            } finally {
                setLoading(false)
            }
        }

        if (filter.StartDate && filter.EndDate) {
            fetchData()
        }
    }, [filter])

    const filterChanged = filterData => {
        setFilter({
            ...filter,
            ...filterData,
        })
    }

    const refresh = () => {
        setFilter({
            ...filter,
        })
    }

    return {
        data,
        error,
        loading,
        filter,
        filterChanged,
        refresh,
    }
}

export const useCustomReportType = reportId => {
    const [reportName, setReportName] = useState('')
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')

    useEffect(() => {
        const fetchReportType = async () => {
            try {
                setLoading(true)
                const result = await ReportService.getCustomReportTypes()
                const reportType = result.find(
                    type => type.ReportId === reportId,
                )
                setReportName(reportType?.ReportName || '')
            } catch (error) {
                setError(error.message || ErrorConstant.default)
            } finally {
                setLoading(false)
            }
        }

        fetchReportType()
    }, [reportId])

    return { reportName, loading, error }
}

export const GetCombineTemplateReport = () => {
    const [data, setData] = useState([])
    const [error, setError] = useState('')
    const [loading, setLoading] = useState(false)
    const [totalCount, setTotalCount] = useState(0)
    const [pagination, setPagination] = useState({
        currentPage: 1,
        lastPage: 1,
        perPage: 20,
        total: 0,
        from: 1,
        to: 20,
    })
    const [filter, setFilter] = useState({
        PageNumber: 1,
        PageSize: CommonConstant.defaultPageSize,
    })

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true)
                const result = await ReportService.getCombineTemplateReportPost(filter)
                setData(result.Items || [])
                if (result.MetaData) {
                    setPagination({
                        currentPage: result.MetaData.CurrentPage,
                        lastPage: result.MetaData.LastPage,
                        perPage: result.MetaData.PerPage,
                        total: result.MetaData.Total,
                        from: result.MetaData.From,
                        to: result.MetaData.To,
                    })
                }
                setTotalCount(result.TotalCount || 0)
            } catch {
                setError(ErrorConstant.default)
            } finally {
                setLoading(false)
            }
        }
        if (filter.StartDate && filter.EndDate) {
            fetchData()
        }
    }, [filter])

    const filterChanged = filterData => {
        const hasFilterChanges = filterData.StartDate || filterData.EndDate ||
            filterData.Status !== undefined || filterData.UserId !== undefined ||
            filterData.customerIds !== undefined

        setFilter({
            ...filter,
            ...filterData,
            PageNumber: hasFilterChanges ? 1 : (filterData.PageNumber || filter.PageNumber),
            PageSize: 20,
        })
    }

    const pageChanged = page => {
        setFilter({
            ...filter,
            PageNumber: page,
        })
    }

    const refresh = () => {
        setFilter({
            ...filter,
        })
    }

    return {
        data,
        error,
        setData,
        loading,
        filter,
        totalCount,
        pagination,
        filterChanged,
        pageChanged,
        refresh,
    }
}

export const GetClaimList = (templateUniqueId = 129321) => {
    const [data, setData] = useState([])
    const [error, setError] = useState('')
    const [loading, setLoading] = useState(false)
    const [totalCount, setTotalCount] = useState(0)
    const [filter, setFilter] = useState({
        templateUniqueId,
        q: '',
        phase: '',
        status: '',
        startDate: '',
        endDate: '',
        customerIds: '',
        OriginatorUserId: '',
        RAM: true,
        NonRAM: true,
        pageNumber: 1,
        pageSize: 50,
    })

    useEffect(() => {
        let isMounted = true
        const fetchData = async () => {
            try {
                setLoading(true)
                const result = await ClaimListService.getList(filter)
                if (isMounted) {
                    const parsed = parseClaimListResponse(result)
                    setData(parsed.items)
                    setTotalCount(parsed.totalCount)
                }
            } catch {
                if (isMounted) {
                    setError(ErrorConstant.default)
                    setData([])
                    setTotalCount(0)
                }
            } finally {
                if (isMounted) {
                    setLoading(false)
                }
            }
        }

        fetchData()

        return () => {
            isMounted = false
        }
    }, [filter])

    const filterChanged = useCallback(filterData => {
        setFilter(prev => ({
            ...prev,
            ...filterData,
            pageNumber:
                filterData.pageNumber != null ? filterData.pageNumber : 1,
        }))
    }, [])

    const pageChanged = useCallback(page => {
        setFilter(prev => ({
            ...prev,
            pageNumber: page,
        }))
    }, [])

    const refresh = useCallback(() => {
        setFilter(prev => ({ ...prev }))
    }, [])

    return {
        data,
        error,
        setData,
        loading,
        filter,
        totalCount,
        filterChanged,
        pageChanged,
        refresh,
    }
}

export const GetCustomerDefectReport = () => {
    const [data, setData] = useState([])
    const [error, setError] = useState('')
    const [loading, setLoading] = useState(false)
    const [totalCount, setTotalCount] = useState(0)
    const [filter, setFilter] = useState({
        PageNumber: 1,
        PageSize: CommonConstant.defaultPageSize,
    })

    useEffect(() => {
        if (!filter.StartDate || !filter.EndDate) {
            return undefined
        }

        let isMounted = true
        const fetchData = async () => {
            try {
                setLoading(true)
                const result = await ReportService.getCustomDashboardType1(filter)
                if (isMounted) {
                    setData(result.Items || [])
                    setTotalCount(result.TotalCount || 0)
                }
            } catch {
                if (isMounted) {
                    setError(ErrorConstant.default)
                }
            } finally {
                if (isMounted) {
                    setLoading(false)
                }
            }
        }

        fetchData()

        return () => {
            isMounted = false
        }
    }, [filter])

    const filterChanged = filterData => {
        const hasFilterChanges =
            filterData.StartDate ||
            filterData.EndDate ||
            filterData.Status !== undefined ||
            filterData.StatusList !== undefined ||
            filterData.UserId !== undefined ||
            filterData.customerIds !== undefined ||
            filterData.TemplateId !== undefined ||
            filterData.Severity !== undefined

        const nextFilter = {
            ...filter,
            ...filterData,
            PageNumber: hasFilterChanges
                ? 1
                : filterData.PageNumber || filter.PageNumber,
            PageSize:
                filterData.PageSize ||
                filter.PageSize ||
                CommonConstant.defaultPageSize,
        }

        if ('Severity' in filterData && !filterData.Severity) {
            delete nextFilter.Severity
        }

        setFilter(nextFilter)
    }

    const pageChanged = page => {
        setFilter({
            ...filter,
            PageNumber: page,
        })
    }

    const refresh = () => {
        setFilter({ ...filter })
    }

    return {
        data,
        error,
        setData,
        loading,
        filter,
        totalCount,
        filterChanged,
        pageChanged,
        refresh,
    }
}
